import { Button, useTheme, VFlow } from 'bold-ui'
import { Form, FormRenderProps, SubmitButton, TextField } from 'components/form'
import { useHistory } from 'react-router'
import { createValidator, required } from 'util/validation'

export interface SolicitarRecuperarSenhaFormModel {
  usuario: string
}

interface SolicitarRecuperarSenhaFormProps {
  onRequestRedefinicaoSenha(values: SolicitarRecuperarSenhaFormModel): any
  isRecuperarSenhaBloqueado?: boolean
}

const validator = createValidator<SolicitarRecuperarSenhaFormModel>({
  usuario: [required],
})

export const SolicitarRecuperarSenhaForm = (props: SolicitarRecuperarSenhaFormProps) => {
  const theme = useTheme()
  const history = useHistory()
  const { onRequestRedefinicaoSenha, isRecuperarSenhaBloqueado } = props

  const handleCancelar = () => history.push('/')

  const renderForm = (formRenderProps: FormRenderProps) => {
    return (
      <form onSubmit={formRenderProps.handleSubmit} noValidate>
        <VFlow>
          <TextField name='usuario' label='Usuário' required />
          <SubmitButton
            style={{
              color: theme.pallete.gray.c100,
              border: 'none',
            }}
            block
            disabled={isRecuperarSenhaBloqueado ?? false}
            handleSubmit={formRenderProps.handleSubmit}
          >
            Recuperar Senha
          </SubmitButton>

          <Button onClick={handleCancelar} skin='outline' block>
            Cancelar
          </Button>
        </VFlow>
      </form>
    )
  }

  return <Form render={renderForm} onSubmit={onRequestRedefinicaoSenha} validate={validator} />
}
